/** Cashflow month key `YYYY-MM` (e.g. `2025-08`) → short name for chart axes (`Aug`). */
export function formatYmMonthShort(ymKey: string): string {
  const match = /^(\d{4})-(\d{2})$/.exec(ymKey.trim());
  if (!match) return ymKey;
  const y = Number(match[1]);
  const m = Number(match[2]);
  if (!Number.isFinite(y) || m < 1 || m > 12) return ymKey;
  const d = new Date(Date.UTC(y, m - 1, 1));
  return d.toLocaleDateString("en-US", { month: "short", timeZone: "UTC" });
}

/** Same as above but includes two-digit year (`May-25`) for multi-year ranges. */
export function formatYmMonthChartLabel(ymKey: string): string {
  const match = /^(\d{4})-(\d{2})$/.exec(ymKey.trim());
  if (!match) return ymKey;
  const y = Number(match[1]);
  const m = Number(match[2]);
  if (!Number.isFinite(y) || m < 1 || m > 12) return ymKey;
  const d = new Date(Date.UTC(y, m - 1, 1));
  const mon = d.toLocaleDateString("en-US", { month: "short", timeZone: "UTC" });
  const yy = String(y).slice(-2);
  return `${mon}-${yy}`;
}
